import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["playIcon", "equalizer", "audio"]

  declare playIconTarget: HTMLElement
  declare equalizerTarget: HTMLElement
  declare audioTarget: HTMLElement

  private playing = false

  toggle() {
    const audio = this.audioTarget as HTMLAudioElement
    if (this.playing) {
      audio.pause()
      this.playIconTarget.classList.remove("hidden")
      this.equalizerTarget.classList.add("hidden")
      this.playing = false
    } else {
      void audio.play()
      this.playIconTarget.classList.add("hidden")
      this.equalizerTarget.classList.remove("hidden")
      this.playing = true
    }
  }

  ended() {
    this.playIconTarget.classList.remove("hidden")
    this.equalizerTarget.classList.add("hidden")
    this.playing = false
  }
}
